import { useEffect, useRef, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useMediaKit } from '@/hooks/useNewsletter'
import '@/styles/gg.css'
import '@/styles/newsletter.css'

/**
 * A creator's shared media kit. Readable by anyone with the link: the real
 * newsletter with prices on the open spots, who is running and when it frees
 * up. Never what another advertiser paid.
 */
export function MediaKitPublic() {
  const { token } = useParams<{ token: string }>()
  const { data, isLoading } = useMediaKit(token)
  const [params] = useSearchParams()
  const frame = useRef<HTMLIFrameElement>(null)
  const [height, setHeight] = useState(1400)
  const [ready, setReady] = useState(false)
  // ?print=1 opens the print dialog once the newsletter has drawn, so "Save as
  // PDF" gives the advertiser a file they can keep.
  useEffect(() => {
    if (ready && params.get('print') === '1') window.setTimeout(() => window.print(), 400)
  }, [ready, params])
  if (isLoading) return <div className="gg kit"><span className="gg-spinner" /></div>
  if (!data) return <div className="gg kit"><h1 className="kit__title">This media kit link is not valid.</h1></div>
  const s = data.snapshot
  return (
    <div className="gg kit">
      <div className="kit__inner">
        <span className="eyebrow eyebrow--accent">Media kit</span>
        <h1 className="kit__title">Sponsor {data.publication}</h1>
        <p className="gg-help">{data.place}{s.audience ? ` · ${s.audience}` : ''}</p>
        <div className="kit__spots">
          {s.spots.map((sp, i) => (
            <div key={i} className="gg-panel kit__spot">
              <strong>{sp.label}</strong>
              <span>{sp.status === 'open' ? `Open now · ${sp.rate} an issue` : `Taken · frees up ${sp.frees_on ?? 'soon'}${sp.next_rate ? ` · then ${sp.next_rate} an issue` : ''}`}</span>
            </div>
          ))}
        </div>
        {s.contact && <p className="kit__contact">To book a spot, email <a href={`mailto:${s.contact}`}>{s.contact}</a>. You pay the creator directly.</p>}
        <button className="gg-btn gg-btn--sm kit__print" onClick={() => window.print()}>Save as PDF</button>
        <iframe ref={frame} className="kit__frame" title="The newsletter" srcDoc={s.html} sandbox="allow-same-origin" style={{ height }}
          onLoad={() => {
            const d = frame.current?.contentDocument
            if (d) setHeight(Math.max(600, d.documentElement.scrollHeight + 8))
            setReady(true)
          }} />
        <p className="gg-help kit__foot">Made with GoGrov. Created {new Date(data.created_at).toLocaleDateString()}.</p>
      </div>
    </div>
  )
}
